import React, { useEffect, useState, useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ServerContext, StoreContext } from '../../App';
import Preloader from '../../pages/Preloader/Preloader';
import GuestAuthGate, { GuestAuthGateVariant } from '../GuestAuthGate/GuestAuthGate';

interface ProtectedRouteProps {
    children: React.ReactNode;
    /** Для гостя показать экран с кнопками входа/регистрации вместо редиректа на /login */
    guestGateVariant?: GuestAuthGateVariant;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, guestGateVariant }) => {
    const store = useContext(StoreContext);
    const server = useContext(ServerContext);
    const location = useLocation();
    const [isChecking, setIsChecking] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const checkSession = async () => {
            const token = store.getToken();
            
            if (!token) {
                setIsChecking(false);
                setIsAuthenticated(false);
                return;
            }

            // Быстрое восстановление из localStorage
            const savedUser = store.loadUserFromStorage();
            if (savedUser) {
                store.setUser(savedUser);
                setIsAuthenticated(true);
            }

            // Валидация на сервере
            try {
                const sessionCheck = await server.checkSession();
                if (sessionCheck.user) {
                    store.setUser(sessionCheck.user);
                    setIsAuthenticated(true);
                } else if (sessionCheck.isAuthError) {
                    store.clearUser();
                    setIsAuthenticated(false);
                }
            } catch (error) {
                // Сетевая ошибка - используем сохраненные данные
                if (!savedUser) {
                    setIsAuthenticated(false);
                }
            }
            
            setIsChecking(false);
        };

        checkSession();
    }, [store, server]);

    if (isChecking) {
        return <Preloader />;
    }

    if (!isAuthenticated) {
        if (guestGateVariant) {
            return <GuestAuthGate variant={guestGateVariant} />;
        }
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;

